export const TOP_BANNER_HEIGHT = 43;
export const TRANSITION_INTERVAL = 8000;
